<template>
  <div>
    <oil-form v-if='loading'
              :title='title'
              :items='gdt'
              :createForm='!gdt.Id'
              :keys='keys'
              @ImporterId='changeImporter'
              @InvoiceId='changeInvoice'
              @ProductId='changeProduct'
              @CostPerTon='changeCostPerTon'
              @TotalSumac='changeTotalSum'
              :formCallback='formCallback'

    >
      <template v-slot:Registry='{input}'>
        <OilRegistry @calculate='calculate' :disabled='input.isEdit' :items='gdt.Registry' />
      </template>

      <template v-slot:File='{input}'>
        <v-file-input
            @change='fileSave'
            :disabled='!input.isEdit'
            :label='label'
            dense outlined
        />
      </template>

      <template v-slot:Download='{input}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn style='box-shadow: none;color: #00b24f;background-color: transparent' :disabled='!input.isEdit'
                   @click='dow(gdt)'
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Скачать</span>
        </v-tooltip>
      </template>

    </oil-form>
  </div>
</template>

<script>
import keys from './setting/gdt.json'
import { coreApi } from '~/services/core'
import { num2str } from '~/utils/functions/MoneyFromString'
import { fileService } from '~/services/FileNextNumberService'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form'),
    OilRegistry: () => import('./setting/registry')
  },
  data() {
    return {
      loading: false,
      keys: keys,
      title: 'Создать ГТД',
      label: 'загрузить файл',
      gdt: {
        Importer: {},
        Invoice: {},
        Product: {},
        Registry: [],
        Attachment: {},
        Number: '',
        StartDate: '',
        UsDollarRate: '',
        Comment: '',
        TotalQuantityInTons: '',
        CostPerTon: '',
        TotalSumac: '',
        TotalSumacWords: ''
      },
      invoices: [],
      importers: [],
      products: []
    }
  },
  async created() {


    const importers = await coreApi.get(`importer`)
    this.importers = importers.data

    const products = await coreApi.get(`product`)
    this.products = products.data

    if (this.id) {
      this.title = 'Инфо о ГТД'
      const response = await coreApi.get(`gtd?id=${this.id}`)
      const gdt = response.data
      const invoices = await coreApi.get(`importer-invoice/importer/${gdt.Importer.Id}`)
      this.invoices = invoices.data
      this.gdt = gdt
      this.label = gdt?.Attachment?.Name || 'загрузить файл'
      this.gdt.TotalQuantityInTons = parseFloat(gdt?.TotalQuantityInTons).toFixed(4)
      this.gdt.TotalSumac = parseFloat(gdt?.TotalSumac).toFixed(2)
    }

    this.loading = true
  },
  computed: {

    storeType() {
      return this.id ? coreApi.put : coreApi.post
    },
    message() {
      return this.id ? 'ГДТ удачно изменен' : 'ГДТ удачно создан'
    }
  },
  methods: {
    async formCallback(data, input, form, func) {
      input.isEdit = false
      const response = await this.storeType('gtd', data)

      func(this.message)

      this.gdt = response.data

      if (!this.id) {
        await this.$router.push({
          name: 'gdt',
          params: { id: this.gdt.Id }
        })
      }
    },
    async fileSave(file) {
      const fileId = await fileService.generateId()
      const res = await fileService.upload(fileId.data.Id, file)
      this.gdt.Attachment = res.data
      // if (!(file instanceof File)) return
      // const arrayPromise = new Promise(function(resolve) {
      //   const reader = new FileReader()
      //   reader.onloadend = function() {
      //     const arrays = []
      //     const uint8Array = new Uint8Array(reader.result)
      //     for (const uints of uint8Array) {
      //       arrays.push(uints)
      //     }
      //     resolve(arrays)
      //     reader.abort()
      //   }
      //   reader.readAsArrayBuffer(file)
      // })
      //
      // const bytes = await arrayPromise
      //
      // this.gdt.Attachment = {
      //   Name: file.name,
      //   ByteData: bytes
      // }


    },
    calculate(registry) {
      let sum = 0
      registry.forEach(({ WeightTon }) => sum += parseFloat(WeightTon))
      sum = (sum.toFixed(4) || null)
      if (isNaN(sum)) sum = ''
      this.gdt.TotalQuantityInTons = sum
    },
    async changeImporter(importer) {
      if (!importer) return
      this.gdt.Importer = { ...importer }
      const invoices = await coreApi.get(`importer-invoice/importer/${importer.Id}`)
      this.invoices = invoices.data
    },
    async changeInvoice(invoice) {
      if (!invoice) return
      this.gdt.Invoice = invoice
      this.gdt.Product = { ...invoice.Product }
    },
    async changeProduct(product) {
      if (!product) return
      this.gdt.Product = { ...product }
    },
    async changeTotalSum(sum) {
      this.gdt.CostPerTon = (sum / this.gdt.TotalQuantityInTons).toFixed(2)
      this.gdt.TotalSumacWords = num2str(sum)
    },
    async changeCostPerTon(costPerTon) {
      const { TotalQuantityInTons } = this.gdt

      this.gdt.TotalSumac = (TotalQuantityInTons * costPerTon) || null

      this.gdt.TotalSumacWords = num2str(this.gdt.TotalSumac)
    }
    // async changeTotalQuantity(totalQuan) {
    //   this.gdt.CostPerTon =  (this.gdt.TotalSumac/totalQuan).toFixed(4)
    //   this.gdt.TotalSumacWords = num2str(this.gdt?.TotalSumac)
    // }

  },
  watch: {
    invoices(invoices) {
      this.keys['Invoice.Id'].attrs.items = invoices
    },
    importers(importers) {
      this.keys['Importer.Id'].attrs.items = importers
    },
    products(products) {
      this.keys['Product.Id'].attrs.items = products
    },
    'gdt.TotalQuantityInTons'(totalQuan) {
      this.gdt.CostPerTon = (this.gdt.TotalSumac / totalQuan).toFixed(2)
      this.gdt.TotalSumacWords = num2str(this.gdt?.TotalSumac)
    }
  }
}
</script>